import {
  secureBusinessSectionsVulcan,
  secureBusinessPlanVulcan,
  monitorSectionsVulcan,
  protectSectionsVulcan,
  controlSectionsVulcan,
  keyMonitorVulcan,
  keyProtectVulcan,
  keyControlVulcan
} from '../../../utils/constant';
import priceSelectionList from '../utils/getPriceSelectionList';
import getTotalsForSetOfTotals from '../utils/getTotalsForSetOfTotals';
import { setPricingFields, pricingFields } from './secureBusinessFieldNames';

export const getSecureBusinessTotals = (formFields, orderData) => {
  setPricingFields(formFields);
  if (
    formFields[secureBusinessPlanVulcan] &&
    formFields[secureBusinessPlanVulcan].value === keyMonitorVulcan
  ) {
    monitorSectionsVulcan.forEach(section => {
      formFields = { ...formFields, ...formFields[section] };
    });
  } else if (
    formFields[secureBusinessPlanVulcan] &&
    formFields[secureBusinessPlanVulcan].value === keyProtectVulcan
  ) {
    protectSectionsVulcan.forEach(section => {
      formFields = { ...formFields, ...formFields[section] };
    });
  } else if (
    formFields[secureBusinessPlanVulcan] &&
    formFields[secureBusinessPlanVulcan].value === keyControlVulcan
  ) {
    controlSectionsVulcan.forEach(section => {
      formFields = { ...formFields, ...formFields[section] };
    });
  }

  const secureBusinessTotals = getTotalsForSetOfTotals(
    pricingFields,
    formFields,
    orderData
  );
  return secureBusinessTotals;
};

export const getSecureBusinessPriceSelections = formFields => {
  const selectionsList = priceSelectionList(pricingFields, formFields);
  return selectionsList;
};
